import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'lib-data-model-customization-sidebar',
  templateUrl: './data-model-customization-sidebar.component.html',
  styleUrls: ['./data-model-customization-sidebar.component.scss'],
  standalone: false
})
export class DataModelCustomizationSidebarComponent implements OnInit, OnChanges {
  @Input() items: string[] = [];
  @Input() selectedModelText: string = '';
  @Output() itemSelected = new EventEmitter<string>();

  constructor(private route: ActivatedRoute, private router: Router, private location: Location){}

  ngOnInit(): void {
    this.getSelectedItemByUrlId();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedModelText']) {
      this.getSelectedItemByUrlId();
    } 
  }

  selectedItem: string = '';
  
  selectItem(item: string, index: number) {
    this.selectedItem = item;
    this.itemSelected.emit(item);
    this.navigateDataModelCustomization(index);
  }

  navigateDataModelCustomization(id: number) {
    this.router.navigate(['..', id], { relativeTo: this.route });
  }

  getSelectedItemByUrlId() {
    const id = +this.route.snapshot.paramMap.get('id')!;
    this.selectedItem = this.items[id];
  }
}
